import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const OkIcon = ({
  round,
  containerColor,
  containerSize,
  color,
  size,
  onClick,
  className,
}) => (
  <WithIconRounded
    round={round}
    containerColor={containerColor}
    containerSize={containerSize}
    className={className}
    onClick={onClick}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.9375"
        y="1.01367"
        width="13.3333"
        height="13.3333"
        rx="6.66667"
        stroke={color}
        strokeWidth="1.33333"
      />
      <path
        d="M11.9805 5.10938L7.17318 9.88662C7.04288 10.0161 6.8324 10.0158 6.70251 9.88588L5.38059 8.56396"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
      />
    </svg>
  </WithIconRounded>
);

OkIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

OkIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: '#18223D',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 16,
};

export default OkIcon;
